import React from 'react';

export type SettingsType = {
  packagePath: string;
};

export const InitialSettings = {
  packagePath: ''
};

export const SettingsContext = React.createContext<SettingsType>(
  InitialSettings
);
